import { AppService } from './services/app.service';
import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { ErrorModel } from './models/error.model';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { WaitModalComponent } from './shared/components/waitmodal/waitmodal.component';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  private appLoadedEventHandler: Subscription;
  private appErrorEventHandler: Subscription;
  private waitModalRef: NgbModalRef;
  private showWaitTimeoutRef: any;
  isIframe = false;
  loginDisplay = false;

  constructor(
    private appService: AppService,
    private modalService: NgbModal,
    private router: Router,
  ) {
    this.appLoadedEventHandler = this.appService.appLoadedEvent.subscribe(
      () => {
        this.closeWaitModal();
      }
    );
    this.appErrorEventHandler = this.appService.appErrorEvent.subscribe(
      (error: ErrorModel) => {
        this.closeWaitModal();
        if (error.redirect) {
          this.router.navigate(error.redirectPath || ['/error'], {
            state: error,
          });
        }
      }
    );
  }

  ngOnInit(): void {
    this.showWaitTimeoutRef = setTimeout(() => {
      if (this.appService.appUser == null) {
        this.showWaitModal();
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.appLoadedEventHandler) {
      this.appLoadedEventHandler.unsubscribe();
    }

    if (this.appErrorEventHandler) {
      this.appErrorEventHandler.unsubscribe();
    }
  }

  /**
   * Open the modal
   * @returns void
   */
  showWaitModal(): void {
    this.waitModalRef = this.modalService.open(WaitModalComponent, {
      size: 'lg',
      centered: true,
      keyboard: false,
      backdrop: 'static',
    });
  }

  /**
   * Close the modal
   * @returns void
   */
  closeWaitModal(): void {
    clearTimeout(this.showWaitTimeoutRef);
    if (this.waitModalRef) {
      this.waitModalRef.close();
    }
  }
}
